// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"checkboxNew_Checkbox__IGWgc","Box":"checkboxNew_Box__0njdO","Input":"checkboxNew_Input__Gr2hr","BoxChecked":"checkboxNew_BoxChecked__g1Rb1"};